import { modifier } from 'ember-modifier';
import Constants from '../utils/constants';

export default modifier(
    function setQaAttr(element, properties, { selector, attrText }) {
        let qaAttrElement = selector ? element.querySelector(selector) : qaAttrElement;
        if (qaAttrElement) {
            qaAttrElement.setAttribute(Constants.QA_ATTR_NAME, `${Constants.QA_ATTR_PREFIX}_${attrText}`);
        }
    },
    { eager: false },
);
